var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "size=16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.00001 2L14 14M7.05599 7.05802C6.8058 7.30803 6.66517 7.64719 6.66505 8.00089C6.66492 8.35458 6.80531 8.69384 7.05532 8.94402C7.30533 9.19421 7.64449 9.33484 7.99818 9.33496C8.35187 9.33509 8.69113 9.1947 8.94132 8.94469M6.24201 3.57671C6.81362 3.41319 7.40547 3.33127 8.00001 3.33337C10.6667 3.33337 12.8887 4.88871 14.6667 8.00004C14.148 8.90737 13.592 9.68271 12.998 10.3254M11.5713 11.566C10.484 12.2994 9.29468 12.6667 8.00001 12.6667C5.33334 12.6667 3.11134 11.1114 1.33334 8.00004C2.24601 6.40337 3.27534 5.21671 4.42134 4.43937",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.4f02b120cc3555cd9eb593dc9a5505ed.svg";
export { ForwardRef as ReactComponent };